var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import * as Styled from "./family-and-cup-cascade-drawer-button.style";
import { ComponentSelect } from "./component-select";
import { ComponentSection } from "./component-section";
import { drawerTransitionDelay, narrowDrawerWidth, } from "ui/components/elements/custom-drawer/custom-drawer.style";
import * as DrawerStyled from "ui/components/elements/custom-drawer/custom-drawer.style";
import { useBlockingElementEffect } from "hooks/playcanvas/blocking-element-effect";
import { actions, selectors, useAppDispatch, useAppSelector } from "store";
import { MIXED_VALUES_CONSTANT } from "store/types";
var BlockingContent = function (_a) {
    var children = _a.children;
    useBlockingElementEffect();
    return _jsx(_Fragment, { children: children });
};
export var FamilyAndCupCascadeDrawerButton = function (_a) {
    var sidebarWidth = _a.sidebarWidth, cupFamilyOptions = _a.cupFamilyOptions, cupFamilyDropdownImages = _a.cupFamilyDropdownImages, selectedCupFamilies = _a.selectedCupFamilies, onSelectCupFamily = _a.onSelectCupFamily, cupOptions = _a.cupOptions, selectedCupOptions = _a.selectedCupOptions, onSelectCup = _a.onSelectCup, isMultiSelecting = _a.isMultiSelecting, isSelectCupDone = _a.isSelectCupDone, selectedCupsValuesAreTheSame = _a.selectedCupsValuesAreTheSame;
    var t = useTranslation().t;
    var dispatch = useAppDispatch();
    var activeSidebarItemID = useAppSelector(selectors.selectActiveSidebarItemID);
    var isDrawerActive = activeSidebarItemID === "cup-family-drawer";
    var _b = __read(useState(false), 2), isCupPanelOpen = _b[0], setIsCupPanelOpen = _b[1];
    var _c = __read(useState(false), 2), isDrawerMounted = _c[0], setIsDrawerMounted = _c[1];
    var _d = __read(useState(false), 2), isCupPanelMounted = _d[0], setIsCupPanelMounted = _d[1];
    var drawerContentRef = useRef(null);
    var cupPanelRef = useRef(null);
    // Reset cup panel when family drawer closes
    useEffect(function () {
        if (!isDrawerActive) {
            setIsCupPanelOpen(false);
        }
    }, [isDrawerActive]);
    // Delayed mount/unmount for family drawer content
    useEffect(function () {
        if (isDrawerActive) {
            setIsDrawerMounted(true);
            return;
        }
        var timeout = setTimeout(function () { return setIsDrawerMounted(false); }, drawerTransitionDelay);
        return function () { return clearTimeout(timeout); };
    }, [isDrawerActive]);
    // Delayed mount/unmount for cup cascade panel
    useEffect(function () {
        if (isCupPanelOpen) {
            setIsCupPanelMounted(true);
            return;
        }
        var timeout = setTimeout(function () { return setIsCupPanelMounted(false); }, drawerTransitionDelay);
        return function () { return clearTimeout(timeout); };
    }, [isCupPanelOpen]);
    // Close drawer on click outside both drawers
    var handleClickOutside = useCallback(function (event) {
        var isInEl = function (el) {
            if (!el)
                return false;
            var r = el.getBoundingClientRect();
            return (event.clientX >= r.left &&
                event.clientX <= r.right &&
                event.clientY >= r.top &&
                event.clientY <= r.bottom);
        };
        var isInCupPanel = isCupPanelOpen && isInEl(cupPanelRef.current);
        if (!isInEl(drawerContentRef.current) && !isInCupPanel) {
            dispatch(actions.setActiveSidebarItemID());
        }
    }, [dispatch, isCupPanelOpen]);
    useEffect(function () {
        if (isDrawerActive) {
            document.addEventListener("click", handleClickOutside, true);
        }
        else {
            document.removeEventListener("click", handleClickOutside, true);
        }
        return function () {
            return document.removeEventListener("click", handleClickOutside, true);
        };
    }, [handleClickOutside, isDrawerActive]);
    var handleSelectFamily = function (family) {
        onSelectCupFamily(family);
        setIsCupPanelOpen(true);
    };
    var toggleDrawer = function (e) {
        e.stopPropagation();
        if (!isDrawerActive) {
            dispatch(actions.setActiveSidebarItemID("cup-family-drawer"));
            if (selectedCupFamilies.length > 0) {
                setIsCupPanelOpen(true);
            }
        }
        else {
            dispatch(actions.setActiveSidebarItemID(undefined));
        }
    };
    var cupValue = isMultiSelecting && !selectedCupsValuesAreTheSame
        ? t(MIXED_VALUES_CONSTANT)
        : selectedCupOptions.length > 0
            ? selectedCupOptions[0].label
            : undefined;
    return (_jsxs(Styled.Root, { children: [_jsxs(DrawerStyled.SidebarDrawerRoot, { isVisible: isDrawerActive, sidebarWidth: sidebarWidth, drawerWidth: narrowDrawerWidth, children: [_jsx(DrawerStyled.SidebarButtonContainer, { children: _jsx(ComponentSection, { header: t("edit_grip_position.select_cup"), selected: isDrawerActive, onClick: toggleDrawer, value: cupValue, shouldHighlight: !isSelectCupDone }) }), _jsx(DrawerStyled.SidebarDrawerContentContainer, { ref: drawerContentRef, children: isDrawerMounted && (_jsx(DrawerStyled.SidebarDrawerContentRoot, { children: _jsxs(BlockingContent, { children: [_jsx(Styled.DrawerHeader, { children: t("edit_grip_position.select_cup_family") }), _jsx(ComponentSelect, { labels: cupFamilyOptions, values: cupFamilyOptions, images: cupFamilyDropdownImages, selectedValues: selectedCupFamilies, onValueChange: handleSelectFamily, scrollIntoPosition: "nearest" })] }) })) })] }), _jsx(Styled.CupCascadePanel, { ref: cupPanelRef, isVisible: isCupPanelOpen, sidebarWidth: sidebarWidth, drawerWidth: narrowDrawerWidth, children: isCupPanelMounted && (_jsx(DrawerStyled.SidebarDrawerContentRoot, { children: _jsxs(BlockingContent, { children: [_jsx(Styled.DrawerHeader, { children: t("edit_grip_position.select_cup_size") }), _jsx(ComponentSelect, { labels: cupOptions.map(function (o) { return o.label; }), values: cupOptions.map(function (o) { return o.value; }), images: cupOptions.map(function (o) { return o.image; }), selectedValues: selectedCupOptions.map(function (o) { return o.value; }), onValueChange: onSelectCup, scrollIntoPosition: "nearest" })] }) })) })] }));
};
